module.exports = {
      id: "line-arrow-prev-usage",
      viewBox: "0 0 28 28",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#line-arrow-prev",
      toString: function () {
        return this.url;
      }
    }